import { useMutation, useQueryClient } from "react-query";
import FlaschardService from "@/services/flashcard.service";
import { toast } from "react-toastify";
// import useGoBack from "@/hooks/useGoBack";

export const useDeleteFlashcard = () => {
    const queryClient = useQueryClient();
    // const goBack = useGoBack();

    return useMutation({
        mutationFn: (id: string) => FlaschardService.deleteFlashcard(id),

        onSuccess: () => {
            toast.success("Flashcard deleted successfully.");
            queryClient.invalidateQueries({ queryKey: ["flashcards"] });
            window.location.reload();
        },

        onError: () => {
            toast.error("Failed to delete flashcard. Please try again.");
        },
    });
};